import React from 'react'
// libs
import styled from 'styled-components'
// components
import {
  Accordion as AccordionOrigin,
  AccordionSummary as AccordionSummaryOrigin,
  AccordionDetails as AccordionDetailsOrigin
} from '@mui/material'

export const Accordion = styled(({ isDetails, children, ...props }) => (
  <AccordionOrigin {...props}>{children}</AccordionOrigin>
))<{
  isDetails?: boolean
  isProperties?: boolean
}>`
  && {
    border-radius: 4px;
    margin: 16px 0 !important;
    padding: 0 ${({ isProperties }) => (isProperties ? '96px' : '16px')} 0 24px;

    & > div > div {
      font-size: 18px;
      margin-left: 8px;
    }
  }
`

export const AccordionSummary = styled(AccordionSummaryOrigin)`
  && {
    font-family: inherit;
    flex-direction: row-reverse;
    font-size: 16px;
    padding: 0;

    & > :last-child {
      margin: 0;
      padding: 0;

      & > div {
        margin-left: 8px;
      }
    }
  }
`

export const AccordionDetails = styled(AccordionDetailsOrigin)`
  && {
    font-size: 15px;
    padding: 0 0 24px 0;
  }
`

export const SectionsContainer = styled.div`
  padding-bottom: 20px;
`

export const Title = styled.div`
  font-size: 22px;
  margin-top: 16px;
  text-transform: capitalize;
`
